// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-table{
    width: 100%;
    min-width: 1000px;
    overflow-x: auto;
    font-size: 0.9em;
}

.info-table .header-align{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-table th, .info-table td{
    text-align: start;
    padding: 0.6em 0em 0.6em 1em;
    border-bottom: 1px solid var(--black);    
}

.info-table tr td{
    max-height: 4em;
    color: var(--grey);
    padding: 1em 0 1em 1em;
    border-bottom: 1px solid var(--line-color-light);
    background-color: var(--white);
}

.info-table tr.bg-dif td{
    background-color: var(--white-smoke);
}

.info-table tr td input[type=checkbox]{
    position: relative;
    top: 0.16em;
}

.info-table tr .td-actions{ 
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
}

.info-table .show-btn, 
.info-table .edit-btn, 
.info-table .delete-btn{
    font-size: 1.3em;
    width: 1.8em;
    height: 1.8em;
    border: none;
    background: inherit;
    position: relative;
}

.info-table .edit-btn:hover, .info-table .delete-btn:hover{
    cursor: pointer;
}

/* Pagination */

.container-pagination{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 1.5em;
    column-gap: 0.5em;
    padding: 0 4em;
}`, "",{"version":3,"sources":["webpack://./src/pages/settings/table/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gDAAgD;IAChD,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,eAAe;;AAEf;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".info-table{\n    width: 100%;\n    min-width: 1000px;\n    overflow-x: auto;\n    font-size: 0.9em;\n}\n\n.info-table .header-align{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.info-table th, .info-table td{\n    text-align: start;\n    padding: 0.6em 0em 0.6em 1em;\n    border-bottom: 1px solid var(--black);    \n}\n\n.info-table tr td{\n    max-height: 4em;\n    color: var(--grey);\n    padding: 1em 0 1em 1em;\n    border-bottom: 1px solid var(--line-color-light);\n    background-color: var(--white);\n}\n\n.info-table tr.bg-dif td{\n    background-color: var(--white-smoke);\n}\n\n.info-table tr td input[type=checkbox]{\n    position: relative;\n    top: 0.16em;\n}\n\n.info-table tr .td-actions{ \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1em;\n}\n\n.info-table .show-btn, \n.info-table .edit-btn, \n.info-table .delete-btn{\n    font-size: 1.3em;\n    width: 1.8em;\n    height: 1.8em;\n    border: none;\n    background: inherit;\n    position: relative;\n}\n\n.info-table .edit-btn:hover, .info-table .delete-btn:hover{\n    cursor: pointer;\n}\n\n/* Pagination */\n\n.container-pagination{\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 1.5em;\n    column-gap: 0.5em;\n    padding: 0 4em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
